/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistant extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
    });
  }

  playground({ assistantId, messageContent, messageHistory }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
    });
  }

  rotateBeaconToken(assistantId) {
    return axios.post(`${this.url}/${assistantId}/rotate_beacon_token`);
  }

  beaconStats(assistantId) {
    return axios.get(`${this.url}/${assistantId}/beacon_stats`);
  }
}

export default new CaptainAssistant();
